import { ALL_JOBS_REQUEST, ALL_JOBS_SUCCESS, ALL_JOBS_FAIL } from "../constants/AuthConstant";
import axios from "axios";

export const AllNewJobsListAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: ALL_JOBS_REQUEST,
      payload: true,
    });

    try {
      const response = await axios.put(`${process.env.REACT_APP_API_PATH}/ebench/get_all_posted_jobs`,data, {
      
        headers: {
          "Content-Type": "application/json",
        },
      });
      dispatch(loadAllDetailsPre(response.data));
    } catch (error) {
      dispatch({
        type: ALL_JOBS_FAIL,
        payload: false,
        error: error.message,
        msg: "Failed to load the information",
      });
    }
  };
};

export const loadAllDetailsPre = (data) => {
  return {
    type: ALL_JOBS_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS"
  };
};
